import React from "react";
import { toast } from "react-toastify";
import { Icon } from "../../components";
import { toastSettings } from "../../../config/components/toast";

const useNotification = () => {
    const notify = (message, type) => {
        const content = (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {message}
            </div>
        );

        const iconStyle = { width: 20, height: 20 };

        const iconMap = {
            success: (
                <Icon alt="success" icon="success-icon" style={iconStyle} />
            ),
            error: <Icon alt="error" icon="error-icon" style={iconStyle} />,
            info: <Icon alt="info" icon="info-icon" style={iconStyle} />,
            warning: (
                <Icon alt="warning" icon="warning-icon" style={iconStyle} />
            ),
        };

        const options = {
            ...toastSettings,
            icon: iconMap[type] || false, // disables default icon if there's no type
        };

        switch (type) {
            case "success":
                toast.success(content, { ...options });
                break;
            case "error":
                toast.error(content, { ...options });
                break;
            case "info":
                toast.info(content, { ...options });
                break;
            case "warning":
                toast.warning(content, { ...options });
                break;
            default:
                toast(content, { ...options });
                break;
        }
    };

    return notify;
};

export default useNotification;
